class VatValidationManager {
    constructor() {
        this.timer = null;
        this.isChecking = false;
        this.initializedForms = new WeakSet();
        this.waitForForm();
    }

    waitForForm() {
        const startedAt = Date.now();
        const interval = setInterval(() => {
            const $mainContent = $('#MainContent');
            const $forms = $mainContent.find('form[data-cf-form]').filter((_, form) => {
                return $(form).find('.js-vat input').length > 0;
            });

            if (Date.now() - startedAt > 15000) {
                clearInterval(interval);
            }

            if (!$forms.length) {
                return;
            }

            $forms.each((_, formElement) => {
                if (this.initializedForms.has(formElement)) {
                    return;
                }

                this.initializedForms.add(formElement);

                const $form = $(formElement);
                this.init($form, $form.find('.js-vat input'));
            });
        }, 100);
    }

    // ---------------------------------------------------------
    // Initialisierung
    // ---------------------------------------------------------
    init(form, vatInput) {

        // -------------------------------
        // i18n absichern
        // -------------------------------
        if (!window.VAT_I18N) {
            console.error('VAT_I18N missing: vat_i18n.js not loaded');
            return;
        }

        const lang = (document.documentElement.lang?.toLowerCase() || 'de').split('-')[0];
        const VAT_T = VAT_I18N[lang] || VAT_I18N.de;

        let messageBox = null;

        const submitBtn = form.find('button.cf-submit-form');
        let submitGuard = null;

        const ensureGuard = () => {
            if (!submitGuard) {
                submitGuard = $('<div class="vat-submit-guard"></div>');
                submitBtn.after(submitGuard);
            }
        };

        const removeGuard = () => {
            if (submitGuard) {
                submitGuard.remove();
                submitGuard = null;
            }
        };

        const needsVatCheck = () => {
            return form.find('.js-vat').is(':visible')
                && vatInput.val().trim() !== '';
        };

        // -----------------------------------------------------
        // Wechsel B2B → B2C → Reset
        // -----------------------------------------------------
        form.on('change', '.js-c-group select', () => {
            if (!form.find('.js-vat').is(':visible')) {
                vatInput.val('');
                if (messageBox) messageBox.html('');
            }
        });

        // ------------------------------------------
        // Guard-Click → VAT prüfen → echtes Submit
        // ------------------------------------------
        form.on('click', '.vat-submit-guard', (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (this.isChecking) {
                return; // Throttle: schon in Prüfung
            }

            this.isChecking = true;

            const payload = getPayload();
            ensureMessageBox();
            this.showVatMessage(messageBox, `<div class="vat-message loading">${VAT_T.loading}</div>`);

            this.runVatCheck(payload, VAT_T, messageBox, form, () => {
                this.isChecking = false;
                removeGuard();

                submitBtn.trigger('click'); // echter Submit
            });
        });

        // ------------------------------------------
        // Guard aktivieren / deaktivieren
        // ------------------------------------------
        form.on('input change', () => {
            if (needsVatCheck()) {
                ensureGuard();
            } else {
                removeGuard();
            }
        });

        // ------------------------------------------
        // Enter deaktivieren, wenn VAT sichtbar
        // ------------------------------------------
        form.on('keydown', (event) => {
            if (event.key === 'Enter') {

                // Nur blockieren, wenn VAT sichtbar + relevant
                if (form.find('.js-vat').is(':visible')) {
                    event.preventDefault();
                    event.stopPropagation();

                    if (typeof messageBox !== 'undefined' && messageBox) {
                        this.showVatMessage(messageBox, `<div class="vat-warning">${VAT_T.submitBlocked}</div>`, true);
                    }

                    return false;
                }
            }
        });

        // -------------------------------
        // Payload Builder
        // -------------------------------
        const getPayload = () => ({
            vat: form.find('.js-vat input').val().trim(),
            company: form.find('.js-company input').val().trim(),
            country: (form.find('.js-country select').val() || '').trim(),
            street: form.find('.js-street input').val().trim(),
            zip: form.find('.js-zip input').val().trim(),
            city: form.find('.js-city input').val().trim(),
            email: form.find('.js-email input').val().trim(),
            firstname: form.find('.js-firstname input').val().trim(),
            lastname: form.find('.js-lastname input').val().trim()
        });

        const ensureMessageBox = () => {
            if (!messageBox) {
                messageBox = $('<div class="vat-message vat-message-box" role="alert" aria-live="assertive" tabindex="-1"></div>');
            }

            if (!messageBox.parent().length) {
                const actions = submitBtn.closest('.cf-form-actions');

                if (actions.length) {
                    actions.after(messageBox);
                } else if (submitGuard && submitGuard.parent().length) {
                    submitGuard.after(messageBox);
                } else if (submitBtn.length) {
                    submitBtn.after(messageBox);
                } else {
                    form.append(messageBox);
                }
            }
        };
    }

    // ---------------------------------------------------------
    // VAT-Prüfung
    // ---------------------------------------------------------
    runVatCheck(payload, VAT_T, messageBox, form, onSuccess) {

        $.ajax({
            url: 'https://webhooks.k-tape.com/vat-check.php',
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(payload),
            success: (response) => {
                this.isChecking = false;

                if (typeof response === 'string') {
                    try {
                        response = JSON.parse(response);
                    } catch {
                        response = {};
                    }
                }

                // voll qualifiziert
                if (response.valid === true && response.qualified === true) {
                    this.showVatMessage(messageBox, `<div class="vat-success">${VAT_T.success}</div>`);

                    const exempt = form.find('.exempt-taxes input');
                    const verified = form.find('.vat_verified input');

                    if (!exempt.prop('checked')) {
                        exempt[0].click(); // echtes DOM-Click-Event
                    }

                    if (!verified.prop('checked')) {
                        verified[0].click();
                    }

                    if (typeof onSuccess === 'function') {
                        onSuccess();
                    }

                    return;
                }

                // temporärer Fehler
                if (response.temporary === true) {
                    this.showVatMessage(messageBox, `<div class="vat-error">${VAT_T.serviceDown}</div>`, true);
                    return;
                }

                // normale Fehler
                const msg =
                    Array.isArray(response.errors)
                        ? response.errors.map(k => VAT_T[k] || VAT_T.unknownError).join(' ')
                        : (response.error || VAT_T.unknownError);

                this.showVatMessage(messageBox, `<div class="vat-error">${msg}</div>`, true);
            },
            error: () => {
                this.isChecking = false;
                this.showVatMessage(messageBox, `<div class="vat-error">${VAT_T.serviceDown}</div>`, true);
            }
        });
    }

    showVatMessage(messageBox, html, focus = false) {
        messageBox.html(html);

        if (focus && messageBox[0]) {
            messageBox[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
            messageBox.trigger('focus');
        }
    }
}
